import DOMPurify from 'isomorphic-dompurify';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { OocvTableFragmentFragmentDoc } from '@packages/gql/generated/shopping/OocvTableFragmentFragmentDoc';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@packages/shared';

/* GraphQL */ `
  fragment OocvTableFragment on OocvTable {
    headline
    rows {
      key
      value
    }
  }
`;

export type OocvTableProps = {
  oocvTableData: FragmentType<typeof OocvTableFragmentFragmentDoc>;
};

/**
 * `OocvTable` is a predefined custom table with one table head and n table rows.
 * It is built using the mui table components.
 * */
export const OocvTable = ({ oocvTableData }: OocvTableProps) => {
  const { headline, rows } = getFragmentData(OocvTableFragmentFragmentDoc, oocvTableData);

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell colSpan={2} variant="head">
            {headline}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <TableRow key={idx}>
            <TableCell>{row.key}</TableCell>
            <TableCell>
              <Box
                sx={{ whiteSpace: 'pre-line' }}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(row.value),
                }}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
